<app-top-navigational-panel>TNP loaded</app-top-navigational-panel>
<app-left-navigational-panel>LNP loaded</app-left-navigational-panel>
<p>opportunity works!</p>
